import {State as LoadingState} from '_/utilities/types';

import {Action, ActionType} from './actions';

type State = {
  error: Error | null;
  result: any;
  status: LoadingState;
};

/**
 * @deprecated remove as soon as SelectBox gets removed
 */
export const initialState: State = {
  error: null,
  result: null,
  status: LoadingState.Loading,
};

/**
 * @deprecated remove as soon as SelectBox gets removed
 */
export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionType.SetLoading:
      return initialState;

    case ActionType.SetResult:
      return {
        ...state,
        result: action.payload.result,
        status: LoadingState.Success,
      };

    case ActionType.SetError:
      return {
        ...state,
        error: action.payload.error,
        status: LoadingState.Error,
      };

    /* istanbul ignore next */
    default:
      return state;
  }
}
